import { AppsmenError, PaymentLedger } from "@/shared/utils/interfaces";
import { useMutation } from "@tanstack/react-query";
import useSinglePaymentLedgerSpecificPost from "./useSinglePaymentLedgerSpecificPost";
import useSessionPaymentLedgerSpecificPost from "./useSessionPaymentLedgerSpecificPost";

type PaymentLedgerPost = {
  orderId: number;
  paymentAmount: string;
  isSession: boolean;
};

const usePaymentLedgerPost = () => {
  const singlePaymentLedger = useSinglePaymentLedgerSpecificPost();
  const sessionPaymentLedger = useSessionPaymentLedgerSpecificPost();

  const mutation = useMutation<
    PaymentLedger[],
    AppsmenError,
    PaymentLedgerPost
  >({
    mutationFn: ({ orderId, paymentAmount, isSession }) => {
      return (
        isSession ? sessionPaymentLedger : singlePaymentLedger
      ).mutateAsync({
        orderId: orderId,
        parts: [paymentAmount],
      });
    },
  });

  return mutation;
};

export default usePaymentLedgerPost;
